exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/*\n * Copyright 2017 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2017 Palantir Technologies, Inc. All rights reserved.\n */\n.RouterLoading {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n  .RouterLoading .spinner {\n    align-self: center;\n    margin: auto; }\n", ""]);

